/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import R from 'ramda'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import moment from 'moment'

import { ListItem as MaterialListItem,
         GridList, Subheader, GridTile, IconButton,
         CircularProgress, RaisedButton } from 'material-ui'
import { ListItem } from 'generic/list'
import AlertModal from 'generic/dialog/AlertModal'
import { red500 } from 'material-ui/styles/colors'
import Delete from 'material-ui/svg-icons/action/delete'
import { Typography } from '@material-ui/core'

import * as constants from 'constants/Prestation'
import * as loginConstants from 'constants/Login'

import * as actions from 'actions/ApplicantPrestation'
import * as documentActions from 'actions/Document'
import ImageDisplay from 'components/common/ImageDisplay'

class MoreInformationPanel extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.state = {
      prestation: props.prestation,
      showDocument: false,
      document: undefined,
      showDocumentDeleteConfirmation: false,
      selectedDocument: undefined,
      documentLoading: false,
      documentMessage: undefined
    }
  }

  componentDidMount() {
    this.handleLoadDocuments(this.state.prestation)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.prestation !== prevProps.prestation) {
      this.handleLoadDocuments(this.props.prestation)
    }

    if (this.state.prestation !== prevState.prestation) {
      this.props.handleUpdatedPrestation(this.state.prestation)
    }
  }

  async handleLoadDocuments(prestation) {
    let documents = prestation.documents
    const query = {
      prestation_uid: prestation.uid
    }

    documents = await documentActions.getDocuments(query)
      .then((result) => {
        return result.objects
      })

    this.setState({
      prestation: {
        ...this.props.prestation,
        documents: documents
      }
    })
  }

  handleDocumentDialogConfirm() {
    this.setState({
      showDocument: false
    })
  }

  handleDocumentModal(event) {
    this.setState({
      showDocument: true,
      document: event.target.src
    })
  }

  handleShowConfirmation(event, selectedDocument) {
    this.setState({
      showDocumentDeleteConfirmation: !this.state.showDocumentDeleteConfirmation,
      selectedDocument: selectedDocument
    })
  }

  handleDocumentDeleteConfirm() {
    this.props.handleUpdatedPrestation(this.state.prestation, { disableImage: true })
    
    documentActions.deleteDocument(this.state.selectedDocument)
      .then(() => {
        let documents = this.state.prestation.documents

        if (this.props.updateSelectedPrestation) {
          this.props.updateSelectedPrestation(this.state.prestation)
        }

        const index = documents.findIndex((doc) => doc.uid === this.state.selectedDocument.uid)
        if (index > -1) {
          documents.splice(index, 1)
        }

        this.setState(prev => ({
          prestation: {
            ...prev.prestation,
            document_count: prev.document_count - 1,
            documents: documents,
          }
        }))

        this.setState({
          selectedDocument: undefined,
          showDocumentDeleteConfirmation: false
        })
      })
  }

  handleFileUpload () {
    this.upload.click()
  }

  async handleDocumentChange (event, value) {
    const file = event.target.files[0]

    if (['image/png', 'image/jpg', 'image/jpeg'].indexOf(file.type) === -1) {
      this.setState({
        documentMessage: this.props.intl.formatMessage(constants.messages.IMAGE_ERROR_MESSAGE_LABEL)
      })

      return
    }

    this.setState({
      documentMessage: undefined,
      documentLoading: true
    })

    this.props.handleUpdatedPrestation(this.state.prestation, { disableImage: true })

    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })

    const documentObj = {
      document: base64.split(',')[1],
      value: file.name,
      mimetype: 'data:' + file.type,
      prestation: this.state.prestation.id,
    }

    documentActions.postDocument(documentObj)
      .then((result) => {
        this.setState(prev => ({
          prestation: {
            ...prev.prestation,
            document_count: prev.document_count + 1,
            documents: [
              ...prev.prestation.documents,
              result
            ],
          },
          documentLoading: false
        }))
      })
  }

  render () {
    const isStaff = this.props.user.is_staff
    const role = this.props.user.role
    const prestationStep = this.state.prestation &&
                           this.state.prestation.workflow_objects.length &&
                           this.state.prestation.workflow_objects[0].step_name

    return (
      <React.Fragment>
        <MaterialListItem
          primaryText={this.props.intl.formatMessage(constants.messages.DETAIL_INFORMATIONS_LABEL)}
          initiallyOpen={false}
          primaryTogglesNestedList={true}
          nestedItems={[
            <MaterialListItem
              key={1}
              disabled={true}
              style={{margin: 0, padding: 0}}
            >
              <div
                className='row'
                style={{marginLeft: 5}}
              >
                <div className="col-md-6 col-xs-12">
                  <ListItem
                    key={1}
                    disabled={true}
                    primaryText={this.state.prestation.prestation_type.value}
                    secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_PRESTATION_TYPE_LABEL)}
                  />
                  <ListItem
                    key={2}
                    disabled={true}
                    primaryText={
                        <Typography style={styles.textStyle}>
                          {this.state.prestation.reason ? this.state.prestation.reason : this.props.intl.formatMessage(constants.messages.DETAIL_NO_REASON_LABEL)}
                        </Typography>
                    }
                    secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_REASON_LABEL)}
                  />
                  {
                    this.state.prestation.remarks
                      ? <ListItem
                        key={0}
                        disabled={true}
                        primaryText={
                            <Typography style={styles.textStyle}>
                              {this.state.prestation.remarks}
                            </Typography>
                        }
                        secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_REMARKS_LABEL)}
                      />
                      : undefined
                  }

                  {
                    this.state.prestation.invoice_aba_code &&
                    (isStaff ||
                    role === loginConstants.PAYING_CUSTOMER_ROLE)
                      ? <ListItem
                        key={1}
                        disabled={true}
                        primaryText={this.state.prestation.invoice_aba_code}
                        secondaryText={this.props.intl.formatMessage(constants.messages.INVOICE_ABA_CODE_LABEL)}
                      />
                      : undefined
                  }

                  {
                    this.state.prestation.invoice_date &&
                    (isStaff ||
                    role === loginConstants.PAYING_CUSTOMER_ROLE)
                      ? <ListItem
                        key={2}
                        disabled={true}
                        primaryText={moment(this.state.prestation.invoice_date).format('DD.MM.YYYY')}
                        secondaryText={this.props.intl.formatMessage(constants.messages.INVOICE_DATE_LABEL)}
                      />
                      : undefined
                  }

                  {
                    this.state.prestation.bar_codes
                      ? <ListItem
                        disabled={true}
                        primaryText={this.state.prestation.bar_codes}
                        secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_BAR_CODE_LABEL)}
                        style={{lineBreak: 'anywhere'}}
                      />
                      : undefined
                  }
                </div>

                <div className="col-md-6 col-xs-12">
                  {
                    this.state.documentLoading
                      ? <CircularProgress
                        className='inline center'
                        size={30}
                        style={{paddingTop: 5}}
                      />
                      : isStaff &&
                        prestationStep &&
                        prestationStep !== constants.TO_VALIDATE_PRESTATION_STATUS
                        ? <div>
                          <input
                            name='documents'
                            accept='.jpg, .jpeg, .png'
                            type="file"
                            ref={(ref) => this.upload = ref}
                            style={{display: 'none'}}
                            onChange={this.handleDocumentChange}
                          />
                          <RaisedButton
                            style={{width: '70%', textOverflow: 'ellipsis'}}
                            labelStyle={{fontSize: 12, padding: 0}}
                            primary={true}
                            label={this.props.intl.formatMessage(constants.messages.UPLOAD_IMAGE_LABEL)}
                            onClick={this.handleFileUpload}
                          />
                          <div style={{color: 'red'}}>
                            { this.state.documentMessage }
                          </div>
                        </div>
                        : undefined
                  }

                  {
                    (isStaff ||
                    role === loginConstants.PAYING_CUSTOMER_ROLE ||
                    role === loginConstants.INTERPRETER_ROLE) &&
                    this.state.prestation.documents.length
                      ? <GridList
                        cols={1}
                        cellHeight={200}
                        rows={10}
                      >
                        <Subheader style={{fontWeight: 'initial', color: '#0000008a'}}>
                          {this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_DOCUMENT_LABEL)}
                        </Subheader>
                        {
                          this.state.prestation.documents.map((doc, index) => (
                            <GridTile
                              key={index}
                              titleStyle={{fontSize: 13}}
                              title={moment(doc.creation_time).format('DD.MM.YYYY HH:mm')}
                              actionIcon={
                                isStaff &&
                                !R.path(['is_archived'], doc)
                                ? <IconButton
                                  onClick={e => this.handleShowConfirmation(e, doc)}
                                >
                                  <Delete color={red500}/>
                                </IconButton>
                                : undefined
                              }
                              style={{maxWidth: 265}}
                            >
                              <img
                                onClick={this.handleDocumentModal}
                                src={doc.mimetype + ';base64,' + doc.document}
                                alt=''
                                style={{cursor: 'pointer'}}
                              />
                            </GridTile>
                          ))
                        }
                      </GridList>
                      : this.state.prestation.documents.length
                        ? <ListItem
                          disabled={true}
                          primaryText={this.props.intl.formatMessage(constants.messages.DETAIL_PICTURE_AVAILABLE_LABEL)}
                          secondaryText={this.props.intl.formatMessage(constants.messages.DETAIL_VALIDATION_DOCUMENT_LABEL)}
                        />
                        : undefined
                  }
                </div>

              </div>
            </MaterialListItem>
          ]}
        />

        <AlertModal
          modal={true}
          open={this.state.showDocumentDeleteConfirmation}
          title={this.props.intl.formatMessage(constants.messages.DELETE_DOCUMENT_CONFIRMATION_TITLE)}
          type={AlertModal.CONFIRM}
          handleCancel={() => {this.setState({showDocumentDeleteConfirmation: false})}}
          handleConfirm={this.handleDocumentDeleteConfirm}
        >
          <div className='row'>
            {this.props.intl.formatMessage(constants.messages.DELETE_DOCUMENT_CONFIRMATION_MESSAGE)}
          </div>
        </AlertModal>

        <ImageDisplay
        isOpen={this.state.showDocument}
        onClose={this.handleDocumentDialogConfirm}
        imageUrl={this.state.document}
        />
      </React.Fragment>
    )
  }
}

const styles = {
  textStyle: {
    marginRight: 5,
    fontSize: '16px',
    height: 'auto',
    overflow: 'visible',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
})

export default connect(
  mapStateToProps, 
  mapActionsToProps
)(injectIntl(MoreInformationPanel))



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/MoreInformationPanel.js